import type { GoalResultChange } from './types';

type GoalWithResult = {
  Id: string;
  displayResult: string | null;
  predefinedResultOption: { Id: string } | null;
};

export const hasAllGoalResultsSet = (
  goals: ReadonlyArray<GoalWithResult>,
  pendingChanges: ReadonlyArray<GoalResultChange>,
): boolean =>
  goals.every((goal) => {
    const pending = pendingChanges.find((c) => c.objectiveId === goal.Id);
    if (pending) {
      return pending.predefinedResultOptionId != null || pending.result != null;
    }
    return goal.predefinedResultOption != null || goal.displayResult != null;
  });
